import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import * as moment from 'moment';
import {DaterangePickerComponent} from 'ng2-daterangepicker';
import {StaticUtils} from '../../utils/static-utils';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss']
})
export class DatePickerComponent implements OnInit {
  @Output() onChange = new EventEmitter<any>();

  label = '';
  options = {};

  private _startDate = moment();
  private _endDate = moment();
  private _minDate: moment.Moment;
  private _maxDate: moment.Moment;
  private _range = 0;

  @ViewChild(DaterangePickerComponent)
  private _picker: DaterangePickerComponent;

  constructor() { }

  ngOnInit() {
    this.options = {
      startDate: this.startDate,
      endDate: this.endDate,
      minDate: this.minDate,
      maxDate: this.maxDate,
      autoUpdateInput: false,
      locale: { format: StaticUtils.formatDate },
      autoApply: true,
      singleDatePicker: false,
      alwaysShowCalendars: true,
      ranges: {
        'Today': [moment(), moment()],
        'Tomorrow': [moment().add(1, 'days'), moment().add(1, 'days')],
        'Next 7 Days': [moment(), moment().add(6, 'days')],
        'Next 30 Days': [moment(), moment().add(29, 'days')],
        'Next 60 Days': [moment(), moment().add(59, 'days')]
        // 'Next 60 Days': [moment().add(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
    };

    this.formatLabel();
  }

  next() {
    this._startDate.add(this.range + 1, 'days');
    this._endDate.add(this.range + 1, 'days');
    this.formatLabel();
    this.syncPicker();
    this.onChange.emit({
      start: this._startDate,
      end: this._endDate
    });
  }

  prev() {
    this._startDate.subtract(this.range + 1, 'days');
    this._endDate.subtract(this.range + 1, 'days');
    this.formatLabel();
    this.syncPicker();
    this.onChange.emit({
      start: this._startDate,
      end: this._endDate
    });
  }

  selectedDate(value: any) {
    this._startDate = value.start;
    this._endDate = value.end;
    this._range = this.endDate.diff(this.startDate, 'days');
    this.formatLabel();
    this.onChange.emit({
      start: this._startDate,
      end: this._endDate
    });
  }

  formatLabel() {
    if (this.range === 0 || StaticUtils.formatDate(this.startDate) === StaticUtils.formatDate(this.endDate)) {
      this.label = StaticUtils.formatDate(this.startDate);
    } else {
      this.label = StaticUtils.formatDateRange(this.startDate, this.endDate);
    }
  }

  syncPicker() {
    if (this._picker && this._picker.datePicker) {
      this._picker.datePicker.startDate = this._startDate;
      this._picker.datePicker.endDate = this._endDate;
      if (this._maxDate) {
        this._picker.datePicker.maxDate = this._maxDate;
      }
      if (this._minDate) {
        this._picker.datePicker.minDate = this._minDate;
      }
    }
  }

  get startDate(): moment.Moment {
    return this._startDate;
  }

  @Input('startDate') set startDate(value: moment.Moment) {
    if (StaticUtils.formatDate(this._startDate) !== StaticUtils.formatDate(value)) {
      this._startDate = value;
      this.formatLabel();
      this.syncPicker();
    }
  }

  get endDate(): moment.Moment {
    return this._endDate;
  }

  @Input('endDate') set endDate(value: moment.Moment) {
    if (StaticUtils.formatDate(this._endDate) !== StaticUtils.formatDate(value)) {
      if (this.range > 0) {
        this._endDate = value;
      } else {
        this._endDate = this._startDate.clone();
      }
      this.formatLabel();
      this.syncPicker();
    }
  }

  get range(): number {
    return this._range > 0 ? this._range : 0;
  }

  @Input('range') set range(value: number) {
    if (this._range !== value) {
      this._range = value;
      this._endDate = this._startDate.clone().add(this.range + 1, 'days');
      this.formatLabel();
      this.syncPicker();
    }
  }

  @Input('minDate') set minDate(value: moment.Moment){
    if (
      (this._minDate !== undefined
        && StaticUtils.formatDate(this._minDate) !== StaticUtils.formatDate(value))
      || (this._minDate === undefined
        && value !== undefined)
    ) {
      this._minDate = value;
      this.syncPicker();
    }
  }

  get minDate(): moment.Moment {
    return this._minDate;
  }

  @Input('maxDate') set maxDate(value: moment.Moment){
    if (
      (this._maxDate !== undefined
        && StaticUtils.formatDate(this._maxDate) !== StaticUtils.formatDate(value))
      || (this._maxDate === undefined
        && value !== undefined)
    ) {
      this._maxDate = value;
      this.syncPicker();
    }
  }

  get maxDate(): moment.Moment {
    return this._maxDate;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/atoms/date-picker/date-picker.component.ts